import React from "react";
import "./auth.css";

const POINTS = [
  { icon: "fas fa-headset", name: "Support", text: "From 10:00 am to 6:00 pm — Call 022 42129000" },
  { icon: "fas fa-route", name: "Live crew transport tracking", text: "Follow every crew pick-up and drop from dispatch to arrival." },
  { icon: "fas fa-hotel", name: "Hotel & transport in one place", text: "Crew stays, hotel shuttles and local vendors managed together." },
];

/**
 * Shared field: one box with the icon inside on the left; children = the input and an optional .au-eye button (inside on
 * the right). Not a Bootstrap input-group: the theme sizes its parts differently, so they did not line up.
 */
export function AuthField({ id, label, icon, error, hint, children }) {
  return (
    <div className="form-group au-field">
      <label htmlFor={id} className="au-label">
        {label}
      </label>
      <div className="au-control">
        <i className={`${icon} au-control__icon`} aria-hidden="true" />
        {children}
      </div>
      {hint}
      {error && <span className="au-error">{error}</span>}
    </div>
  );
}

/**
 * Layout of the login, forgot password and reset password pages: the form panel (logos, title, card, footer) on the left
 * and the Akasa banner on the right (hidden on phones).
 */
export default function AuthShell({ title, hint, children }) {
  return (
    <div className="au-page">
      <div className="au-side">
        <main className="au-main">
          <div className="au-box">
            <div className="au-logos">
              <img src="/assets/img/logo_sst_utwiz2.png" alt="UTWiz" className="au-logo-utwiz" />
              <p className="au-welcome">Welcome to</p>
              <img src="/assets/img/logo_akasa_air.png" alt="Akasa Air" className="au-logo-airline" />
            </div>
            <div className="au-card">
              {title && <h1 className="au-card__title">{title}</h1>}
              {hint && <p className="au-card__hint">{hint}</p>}
              {children}
            </div>
          </div>
        </main>
        <footer className="au-footer">
          <div className="au-footer__powered">
            Powered by
            <a href="https://www.plexitech.com/">
              <img src="/assets/img/logo-plexitech2.png" alt="PlexiTech" />
            </a>
          </div>
          <div className="au-footer__copy">
            &copy; {new Date().getFullYear()} Akasa Air. All rights reserved. ·{" "}
            <a href="https://www.akasaair.com/privacypolicy">Privacy Policy</a>
          </div>
        </footer>
      </div>
      {/* The image is a public/ file: set here so the CSS build does not try to bundle it. */}
      <div className="au-banner" aria-hidden="true" style={{ backgroundImage: "url('/assets/img/banner_akasa_air.jpg')" }}>
        <div className="au-banner__text">
          <div className="au-banner__title">Complete Crew &amp; Logistics Solution</div>
          {POINTS.map((p) => (
            <div key={p.name} className="au-point">
              <span className="au-point__icon">
                <i className={p.icon} />
              </span>
              <div>
                <div className="au-point__name">{p.name}</div>
                <div className="au-point__text">{p.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
